import './App.css?v=5';
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Preloader from "./Preloader"; 
import SitePet from "./SitePet";
import { triggerLogin, supabase, isAuthorizedAdminUser, handleAuthRedirect } from "./supabaseClient";
import Sidebar from './SideBar.js'; 
import PortfolioFooter from "./PortfolioFooter";

const ADMIN_ROUTE = process.env.REACT_APP_ADMIN_ROUTE;

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const containerRef = useRef(null); 
  const [isAdmin, setIsAdmin] = useState(false);
  const [clickCount, setClickCount] = useState(0);

const clickTimeout = useRef(null);

const handleSecretClick = () => {
  setClickCount((prev) => {
    const next = prev + 1;

    // reset timer
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
    }

    clickTimeout.current = setTimeout(() => {
      setClickCount(0);
    }, 1500); // 1.5 sec window

    if (next === 5) {
      triggerLogin();
      return 0;
    }

    return next;
  });
};

useEffect(() => {
  let subscription;

  const init = async () => {
    await handleAuthRedirect();

    if (!supabase) {
      setIsAdmin(false);
      return;
    }

    const {
      data: { session },
    } = await supabase.auth.getSession();
    setIsAdmin(isAuthorizedAdminUser(session?.user));

    const { data } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setIsAdmin(isAuthorizedAdminUser(session?.user));
      }
    );

    subscription = data.subscription;
  };

  init();

  return () => {
    if (subscription) subscription.unsubscribe();
  };
}, []);
  

  if (!isLoaded) {
    return <Preloader onFinish={() => setIsLoaded(true)} />;
  }

  return ( 
    <div className="">
      <div className="screen-1">
          <Sidebar />
        </div>
              <div className='frame6' data-platform data-pet-message="Contact zone reached. I will wave politely.">
                
              </div>
      <SitePet />
    </div>
  );
}

export default App;

